@if (!universalService.isMobileDevice) {
  <div class="modal fade" id="folder-not-supported-modal" role="dialog" tabindex="-1" aria-hidden="true" [ngStyle]="{'display': showFolderNotSupportedPopUp ? 'block' : 'none','opacity': 1, 'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content h-90">
        <div class="modal-header">
          <button type="button" class="close btn-pos" data-dismiss="modal" (click)="renameFolder(false)">
            <span class="NeueFile_Cancel"></span>
            <span class="esc">esc</span>
          </button>
          <h5 class="mb-0">Folder name not supported</h5>
        </div>
        <div class="modal-body border-bottom-0">
          <div class="folder-not-supported-confimration">
            <!-- <ul> -->
            <p class="text"><strong>{{oldFolderName}}</strong> is not supported as it contains one of the following special characters {{unsupportedChars}}</p>
            <p class="text">Nested Folders will be automatically renamed with a underscore ( _ ) in case folder name formats are not supported.</p>
          <!-- </ul> -->
        </div>
        <div class="rename-folder">
          <p class="rename-title">New Folder Name</p>
          <input #newName id="rename_input_box" maxlength="200" class="inputBox" type="text" value="{{currentFolder?.name}}" (input)="newNameValidation(newName.value)" autofocus>
          <div class="inputError">
            @if (universalService.errorMessage!='') {
              <span>{{universalService.errorMessage}}</span>
            }
            @if (universalService.errorMessage=='') {
              <span class="default">Device folder name remains unchanged</span>
            }
          </div>
        </div>
      </div>
      <div class="modal-footer pt-2">
        <!-- Button -->
        <div class="btn-wrap">
          <button class="btn btn-cancel mr-md-5 mb-3 mb-md-0" title="Cancel" id="btn-rename-folder-cancel" (click)="renameFolder(false)">Cancel</button>
          <button class="btn btn-rename" id="btn-rename-folder-rename" title="Rename folder" data-dismiss="modal" (click)="renameFolder(true)" [ngClass]="[ enableButton ? '' : 'disable' ]">Rename</button>
        </div>
      </div>
    </div>
  </div>
</div>
}

@if (universalService.isMobileDevice) {
  <div class="modal fade slide-in-fwd-center" id="m-folder-not-supported-modal" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="m-folder-not-supported-modal" aria-hidden="true" [ngStyle]="{'display':'block', 'opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog" role="document">
      <div class="modal-content animated bounceInUp fixed-bottom">
        <div class="modal-header">
          <h6>Folder name not supported</h6>
        </div>
        <div class="modal-body border-bottom-0">
          <div class="folder-not-supported-confimration">
            <ul>
              <li class="text">FolderName is not supported as it contains one of the following special characters <br> {{unsupportedChars}}</li>
              <li class="text">Nested Folders will be automatically renamed with a underscore ( _ ) in case folder name formats are not supported.</li>
            </ul>
          </div>
          <div class="rename-folder">
            <p class="rename-title">New Folder Name</p>
            <input #newName id="rename_input_box" maxlength="200" class="inputBox" type="text" (keyup)="newNameValidation(newName)" autofocus>
            <div class="inputError">
              @if (universalService.errorMessage!='') {
                <span>{{universalService.errorMessage}}</span>
              }
              @if (universalService.errorMessage=='') {
                <span class="default">Device folder name remains unchanged</span>
              }
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="btn-wrap">
            <button class="btn btn-cancel mr-md-5 mb-3 mb-md-0" title="Cancel" id="btn-cancel" (click)="renameFolder(false)">Cancel</button>
            <button class="btn btn-rename" id="btn-rename" title="Rename folder" data-dismiss="modal" (click)="renameFolder(true)" [ngClass]="[ enableButton ? '' : 'disable' ]">Rename</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}